import { useRef, useState } from 'react';
import { useOutsideClick } from '@kcd/design-system';

import { CloseIcon, InfoCircle16x16Icon } from '~/assets/icons';

export function MembershipDiscountNoticeTooltip() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  const left = ref?.current?.offsetLeft || 150;

  useOutsideClick({
    ref,
    onClick: () => {
      if (visible) {
        setVisible(false);
      }
    },
  });

  return (
    <div className="relative w-16" ref={ref}>
      {visible && (
        <div
          className="absolute left-0 top-20 z-10
          w-[calc(100vw-40px)] max-w-[calc(768px-40px)] rounded-16 border
          border-gray-300 bg-gray-000 px-20 py-16 shadow-[0_4px_8px_0px_rgba(0,0,0,0.1)]"
          style={{
            transform: `translateX(-${left}px)`,
          }}
        >
          <p className="text-gray-1400 typo-paragraph100-semibold">
            나의할인가
          </p>
          <p className="mt-8 text-membershipBlue-text typo-footnote300-semibold">
            할인 받을 수 있는 최적의 혜택이 적용되었어요!
          </p>
          <p className="mt-4 text-description typo-footnote300-regular">
            주문 시 실제 사용되는 쿠폰에 따라 할인 금액이 변동될 수 있습니다.
          </p>
          <CloseIcon
            className="absolute right-20 top-16 size-20 text-icon"
            onClick={() => setVisible(false)}
          />
        </div>
      )}
      <InfoCircle16x16Icon onClick={() => setVisible(true)} />
    </div>
  );
}
